<template>
  <div class="flex-container d-flex flex-column ai-center">
    <div class="section-wrapper d-flex flex-column ai-center mg-150">
      <div class="header-2 kor">지원 대상</div>
      <div class="text-lg mg-50">
        정부 지원 사업을 통해 데이터 활용 및 새로운 서비스를 창출하고 싶은 기업
      </div>
      <div class="flex-container d-flex mg-50">
        <div class="applicant-box">
          <div
            class="flex-container d-flex ai-center jc-center header-2 kor applicant-box-header"
          >
            중소기업
          </div>
          <div
            class="flex-container h-full d-flex flex-column ai-center text-2 jc-center pa-3"
          >
            <div class="whitespace-nowrap">
              <b>[ 중소기업 기본법 시행령 ]</b>
            </div>
            제 3조 (중소기업의 범위)에 해당하는 기업
          </div>
        </div>
        <div class="applicant-box">
          <div
            class="flex-container d-flex ai-center jc-center header-2 kor applicant-box-header"
          >
            1인 창조기업
          </div>
          <div
            class="flex-container h-full d-flex flex-column ai-center text-2 jc-center pa-3"
          >
            <div class="whitespace-nowrap">
              <b>[ 1인 창조기업 육성에 관한 법률 ]</b>
            </div>
            1인 또는 5인 미만의 공동사업자로서<br />
            상시근로자 없이 사업을 영위하는 자
          </div>
        </div>
        <div class="applicant-box">
          <div
            class="flex-container d-flex ai-center jc-center header-2 kor applicant-box-header"
          >
            소상공인
          </div>
          <div
            class="flex-container h-full d-flex flex-column ai-center text-2 jc-center pa-3"
          >
            <div class="whitespace-nowrap">
              <b
                >[ 소기업 및 소상공인<br />
                지원을 위한 특별 조치법 ]</b
              >에
            </div>
            따른 소기업 중 상시근로자가 10명<br />
            미만인 사업자
          </div>
        </div>
        <div class="applicant-box">
          <div
            class="flex-container d-flex ai-center jc-center header-2 kor applicant-box-header"
          >
            예비창업자
          </div>
          <div
            class="flex-container h-full d-flex flex-column ai-center text-2 jc-center pa-3"
          >
            <div class="whitespace-nowrap">
              <b>[ 중소기업창업 지원법 ]</b>
            </div>
            제 2조 및 4조에 따라, 중소기업을<br />
            창업하려는 자로 사업공고일 기준<br />
            신청자 명의 사업체를 보유하고 있지 않은 자
          </div>
        </div>
      </div>
      <div class="mg-150 text-lg">
        사회현안 해결부문에는 공공/연구기관, 대학연구팀, 병원 등도 지원 가능
      </div>
      <div class="flex-container d-flex mg-50">
        <div class="applicant-box">
          <div
            class="flex-container d-flex ai-center jc-center header-2 kor applicant-box-header"
          >
            공공기관
          </div>
          <div
            class="flex-container h-full d-flex flex-column ai-center text-2 jc-center pa-3"
          >
            <div class="whitespace-nowrap">
              <b>[ 공공기관의 운영에 관한 법률 ]</b>
            </div>
            에 따른 경영정보공개시스템 <br />
            '알리오'를 통하여 조회가 <br />가능한 대상 해당<br />
            <a class="text-underline" href="http://www.alio.go.kr/"
              >(알리오 링크 바로가기)</a
            >
          </div>
        </div>
        <div class="applicant-box">
          <div
            class="flex-container d-flex ai-center jc-center header-2 kor applicant-box-header"
          >
            연구기관
          </div>
          <div
            class="flex-container h-full d-flex flex-column ai-center text-2 jc-center pa-3"
          >
            지방공공기관통합공시<br />
            '클린아이'에서 조회 가능한 대상<br />
            <a class="text-underline" href="https://www.cleaneye.go.kr/"
              >(클린아이 링크 바로가기)</a
            >
            *민간 기업의 부설연구소는 기업부설연구소 인정서를 제출할 수 있는
            경우만 해당
          </div>
        </div>
        <div class="applicant-box">
          <div
            class="flex-container d-flex ai-center jc-center header-2 kor applicant-box-header"
          >
            대학연구팀
          </div>
          <div
            class="flex-container h-full d-flex flex-column ai-center text-2 jc-center pa-3"
          >
            <div>
              <b
                >국내 대학에 소속된 <br />
                연구센터 또는 연구팀</b
              >
            </div>
            *국내 대학에 소속된 연구센터 및<br />
            연구팀의 구성은 단일 소속이어야 함<br />
            *사업 수행인력 구성 시, 최소 2인<br />
            이상 구성 필수
          </div>
        </div>
        <div class="applicant-box">
          <div
            class="flex-container d-flex ai-center jc-center header-2 kor applicant-box-header"
          >
            병원
          </div>
          <div
            class="flex-container h-full d-flex flex-column ai-center text-2 jc-center pa-3"
          >
            <div><b>[ 의료법 ]</b></div>
            제 3조에 따른 의료기관
          </div>
        </div>
      </div>
    </div>
    <div class="mg-150" />
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>